import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import {FormattedMessage} from "react-intl";
import {CHAT_TYPE, PLAY_MODE_ACTION} from "utils/constants";
import {quickList} from "./list";
import classNames from "classnames/bind";
import styles from "./index.module.scss";

function QuickChat({onSubmit, onClickChatType, isIPXMode}) {
  const cn = classNames.bind(styles);
  const playOption = useSelector(state => state.playOption);
  const isShow = playOption === PLAY_MODE_ACTION.QUICK_CHAT;

  useEffect(() => {
    if (isShow) {
      onClickChatType(CHAT_TYPE.QUICK_MESSAGE);
    }
  });

  return (
    <div className={cn("quick_chat", isShow && "show", isIPXMode && "ipx_quick")}>
      <div className={styles.wrap}>
        {quickList.map(item => (
          <div className={styles.quick_box} key={item.id} onClick={() => onSubmit(item.text)}>
            <span className={styles.quick_text}>
              <FormattedMessage id={item.text} />
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default QuickChat;
